import React from 'react';

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 px-4">
      <div className="w-full max-w-md rounded-2xl border border-zinc-200 bg-white p-8 shadow-sm">
        <h2 className="text-xl font-semibold text-zinc-900">Something went wrong</h2>
        <p className="mt-2 text-sm text-zinc-500">
          The page hit an unexpected error. You can retry, or reload if it keeps happening.
        </p>
        <pre className="mt-4 max-h-32 overflow-auto rounded-lg bg-zinc-50 p-3 text-xs text-zinc-500">
          {error?.message || 'Unknown error'}
        </pre>
        <div className="mt-4 flex gap-3">
          <button
            type="button"
            className="rounded-lg bg-zinc-900 px-4 py-2 text-sm font-medium text-white hover:bg-zinc-800"
            onClick={resetErrorBoundary || (() => window.location.reload())}
          >
            Try again
          </button>
          <button
            type="button"
            className="rounded-lg border border-zinc-200 px-4 py-2 text-sm font-medium text-zinc-700 hover:bg-zinc-50"
            onClick={() => { window.location.href = '/dashboard'; }}
          >
            Go to Analyze
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorFallback;
